// extracted by mini-css-extract-plugin
export var drawerPaper = "_25-0";
export var itemCard = "_25-1";
export var itemImage = "_25-2";